import { render, staticRenderFns } from "./BrandMediaSkeleton.vue?vue&type=template&id=264f373a&scoped=true&"
import script from "./BrandMediaSkeleton.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaSkeleton.vue?vue&type=style&index=0&id=264f373a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f373a",
  null
  
)

export default component.exports